import styled from 'styled-components';

const StyledBackCircle = styled.circle`
	opacity: 0;
	transition: opacity 0.3s ease;
`;

const StyledGroup = styled.g`
	cursor: pointer;

	&:hover {
		${StyledBackCircle} {
			opacity: 0.5;
		}
	}
`;
export { StyledBackCircle, StyledGroup };
